import { InquiryRequestAndResponse } from './../../inquiry-api/index';

export const mockInquiryResponse: InquiryRequestAndResponse = {
  email: 'xxx@xxx.com',
  name: 'name',
  tag: 'tag',
  message: 'message',
};
